import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Limpia',
    desc: 'Eliminas los 3 alimentos que disparan el dolor en tus manos y rodillas.'
  }, {
    num: '2',
    title: 'Nutre',
    desc: 'Introduces los "Super-Sabores" latinos en tus comidas diarias.'
  }, {
    num: '3',
    title: 'Mueve',
    desc: 'Aplicas estiramientos de cero impacto para lubricar tus cartílagos.'
  }];
  return <section className="py-20 px-6 bg-brand-creamDark" data-id="element-66">
      <div className="max-w-4xl mx-auto" data-id="element-67">
        <FadeIn data-id="element-68">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-69">
            ¿Cómo funciona?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-70">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-71">
              <div className="bg-white p-8 rounded-3xl shadow-soft text-center h-full relative mt-6 md:mt-0" data-id="element-72">
                <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 w-16 h-16 bg-brand-gold text-white rounded-full flex items-center justify-center text-3xl font-bold font-serif shadow-lg border-4 border-brand-creamDark" data-id="element-73">
                  {step.num}
                </div>
                <h3 className="text-2xl font-bold mt-6 mb-4" data-id="element-74">{step.title}</h3>
                <p className="text-brand-brown/80" data-id="element-75">{step.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}